<template lang="html">
  <section class="directorsHero" :class="{directorOpened:directorOpened}">
    <div class="directorsHero__background--front" :style="{backgroundImage: `url(${frontImage})`}">
      <div class="directorsHero__name" v-if="!directorOpened">
        <h2 class="directorsHero__subtitle">
          <span>
            {{firstName}}
          </span>
        </h2>
        <h1 class="directorsHero__title cross" @mousemove="onMouseMove" @mouseenter.self="onMouseEnter" @mouseleave.self="onMouseLeave" @click.stop="onMouseClick">
          <span>
            {{lastName}}
          </span>
        </h1>
      </div>
    </div>
    <div class="directorsHero__background--back" :style="{
      backgroundImage: `url(${backImage})`,
      clipPath: `circle(${clipSize}px at ${mouseX}px ${mouseY}px)`,
      '-webkit-clipPath': `circle(${clipSize}px at ${mouseX}px ${mouseY}px)`
      }">
      <div class="directorsHero__name" v-if="directorOpened">
        <h2 class="directorsHero__subtitle">
          <span>
            {{firstName}}
          </span>
        </h2>
        <h1 class="directorsHero__title">
          <span>
            {{lastName}}
          </span>
        </h1>
      </div>
    </div>

  </section>
</template>

<script>
export default {
  name: 'DirectorsHero',
  props: ['firstName', 'lastName', 'frontImage', 'backImage', 'directorOpened'],
  data() {
    return {
      mouseX: 100,
      mouseY: 200,
      clipSize: 0
    }
  },
  watch: {
    directorOpened(newValue) {
      if (!newValue) this.returnToOrigin();
    }
  },
  methods: {
    onMouseMove(event) {
      if (this.directorOpened) return;
      this.mouseX = event.clientX;
      this.mouseY = event.clientY;
    },
    onMouseEnter() {
      if (this.directorOpened) return;
      let start = null;
      const step = timestamp => {
        start = start || timestamp;
        let progress = timestamp - start;
        this.clipSize = Math.min(progress / 4, 120);
        if (progress < 600) window.requestAnimationFrame(step);
      }
      window.requestAnimationFrame(step);
    },
    onMouseLeave() {
      if (this.directorOpened) return;
      let start = null;
      const step = timestamp => {
        start = start || timestamp;
        let progress = timestamp - start;
        this.clipSize = 120 - progress / 3;
        if (this.clipSize < 0) {
          this.clipSize = 0;
          return;
        }
        if (progress < 600) window.requestAnimationFrame(step);
      }
      window.requestAnimationFrame(step);
      this.clipSize = 0;
    },
    onMouseClick() {
      if (this.directorOpened) return;
      this.$emit('handleOpen');
      let start = null;
      const step = timestamp => {
        start = start || timestamp;
        let progress = timestamp - start + 120;
        this.clipSize = Math.min(progress*1.5, 1e7);
        if (progress < 1200) window.requestAnimationFrame(step);
      }
      window.requestAnimationFrame(step);
    },
    returnToOrigin() {
      let start = null;
      const step = timestamp => {
        start = start || timestamp;
        let progress = timestamp - start;
        this.clipSize = 1200 - progress*2;
        if (this.clipSize < 0) {
          this.clipSize = 0;
          return;
        }
        if (progress < 620) window.requestAnimationFrame(step);
      }
      window.requestAnimationFrame(step);
      this.clipSize = 0;
    }
  }
}
</script>

<style lang="scss">
@import "../styles/config.scss";
.directorsHero {
  position: fixed;
  padding: 0;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all .4s ease-out;
  &.directorOpened {
    pointer-events: none;
  }
  &__background {
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    &--front,
    &--back {
      @extend .directorsHero__background;
    }
    &--back {
      pointer-events: none;
    }
  }
  &__name {
    margin: 0 auto;
    // width: 100%;
    // max-width: 1000px;
    text-align: center;
    transition: all .2s ease-out;
  }
  &__title {
    display: inline-block;
    font-family: CamptonBold;
    font-size: 140px;
    line-height: 1.3;
    letter-spacing: 1px;
    overflow: hidden;
    color: transparent;
    -webkit-text-stroke-width: 1px;
    -webkit-text-stroke-color: var(--Neu01);
    cursor: url('../assets/cross.svg') 34 34, auto;
    span {
      display: inline-block;
    }
  }
  &__subtitle {
    font-family: CamptonBold;
    font-size: 18px;
    letter-spacing: 1px;
    color: var(--Neu01);
    width: 60%;
    text-align: left;
    overflow: hidden;
    display: inline-block;
    span {
      display: inline-block;
    }
  }
  @include mq(0, 768px) {
    &__title {
      font-size: 60px;
    }
  }
  @include mq(0, 360px) {
    &__title {
      font-size: 50px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DirectorsHero.vue